import datasets from "./projects.json";
import projectContent from "./projectContent.json";

export function getStimulusCode(dataset) {
  return (projectContent[dataset?.id]?.references || []).find(reference => reference.kind === "Stimulus code") || null;
}

const sharedProjects = {
  predictive_processing: {
    name: "Predictive Processing",
    summary: "Neural responses across four predictive-mismatch contexts, measured with Neuropixels and two-photon imaging."
  },
  cross_species_v2: {
    name: "Cross-Species V2",
    summary: "Testing whether mouse higher visual areas form a unified V2, using electrophysiology and two-photon calcium imaging."
  }
};

export function getProjectGroups() {
  const groups = new Map();
  datasets.forEach(dataset => {
    const projectId = dataset.projectId || dataset.id;
    if (!groups.has(projectId)) {
      groups.set(projectId, {
        id: projectId,
        name: dataset.name,
        summary: dataset.summary,
        ...sharedProjects[projectId],
        datasets: []
      });
    }
    groups.get(projectId).datasets.push(dataset);
  });
  return Array.from(groups.values());
}